import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'ice',
      d: 'M3.5,-9.5h0.5v0.5h-0.5zM-1.5,-9h0.5v0.5h-0.5zM-2,-8.5h1v0.5h-1zM3,-8.5h0.5v0.5h-0.5zM-2,-8h0.5v0.5h-0.5zM2.5,-8h1.5v1.5h-1.5zM-2.5,-7.5h1v1.5h-1zM2,-6.5h2v1h-2zM-2.5,-6h0.5v0.5h-0.5zM1.5,-5.5h2.5v1h-2.5zM-5,-5h1v0.5h-1zM-5.5,-4.5h1v2h-1zM1.5,-4.5h2v1h-2zM2,-3.5h1.5v0.5h-1.5zM-2,-3h1v1h-1zM2,-3h1v0.5h-1zM-6,-2.5h1.5v1.5h-1.5zM2,-2.5h1.5v1h-1.5zM-2.5,-2h1.5v2h-1.5zM2.5,-1.5h1v1.5h-1zM-6.5,-1h2.5v0.5h-2.5zM-6.5,-0.5h1v0.5h-1zM-6.5,0h0.5v0.5h-0.5zM-3,0h0.5v0.5h-0.5zM-0.5,0h0.5v0.5h-0.5zM2,0h1.5v0.5h-1.5zM0,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'frozenWater',
      d: 'M-0.5,-13.5h0.5v0.5h-0.5zM0,-12.5h0.5v1h-0.5zM0,-11.5h1v0.5h-1zM0.5,-11h0.5v0.5h-0.5zM0.5,-10.5h1v1h-1zM0.5,-9.5h1.5v1h-1.5zM-1,-9h0.5v1h-0.5zM0,-8.5h2v0.5h-2zM-1.5,-8h4v1.5h-4zM-1.5,-6.5h3.5v1h-3.5zM-4,-5.5h2v1h-2zM-1.5,-5.5h3v1h-3zM-4.5,-4.5h2v2h-2zM-1,-4.5h2.5v1h-2.5zM-1,-3.5h3v0.5h-3zM-0.5,-3h2.5v1h-2.5zM-4.5,-2.5h2.5v0.5h-2.5zM-4.5,-2h2v1h-2zM0,-2h2v0.5h-2zM0,-1.5h2.5v1.5h-2.5zM-4,-1h1.5v1h-1.5zM-3.5,0h0.5v0.5h-0.5zM0,0h2v0.5h-2z',
    },
    {
      paint: 'icicle',
      d: 'M4,-8h0.5v1h-0.5zM4,-7h1v1h-1zM4,-6h1.5v2h-1.5zM4,-4h2v2.5h-2zM3.5,-1.5h3v2.5h-3z',
    },
    {
      paint: 'snowCap',
      d: 'M-1,-14h0.5v1h-0.5zM-1,-13h1v1h-1zM-1.5,-12h1.5v1h-1.5zM-1.5,-11h2v1h-2zM-2,-10h2.5v1h-2.5zM4,-10h0.5v1h-0.5zM-2,-9h0.5v0.5h-0.5zM-0.5,-9h1v0.5h-1zM3.5,-9h1v0.5h-1zM-0.5,-8.5h0.5v0.5h-0.5zM3.5,-8.5h1.5v0.5h-1.5zM-4,-8h0.5v0.5h-0.5zM4.5,-8h0.5v1h-0.5zM-4.5,-7.5h1.5v1h-1.5zM-4.5,-6.5h2v0.5h-2zM5,-6.5h0.5v0.5h-0.5zM-5,-6h2.5v0.5h-2.5zM-5,-5.5h1v0.5h-1zM0.5,0.5h0.5v0.5h-0.5zM-3,1h4.5v0.5h-4.5zM-2.5,1.5h3.5v0.5h-3.5z',
    },
    {
      paint: 'epicCrystal',
      d: 'M-2,-6h0.5v1.5h-0.5zM-2.5,-4.5h1.5v1.5h-1.5zM3.5,-4.5h0.5v1.5h-0.5zM-2.5,-3h0.5v0.5h-0.5zM-1,-3h0.5v1h-0.5zM3,-3h1v0.5h-1zM3.5,-2.5h0.5v1h-0.5zM-1,-2h1v2h-1z',
    },
    {
      paint: 'snowGround',
      d: 'M-5.5,-0.5h1.5v0.5h-1.5zM-6,0h2.5v0.5h-2.5zM-2.5,0h2v0.5h-2zM-6.5,0.5h6.5v0.5h-6.5zM1,0.5h2.5v0.5h-2.5zM-5,1h2v0.5h-2zM1.5,1h4.5v0.5h-4.5zM-4,1.5h1.5v0.5h-1.5zM1,1.5h3v0.5h-3zM1.5,2h0.5v0.5h-0.5z',
    },
  ],
  pixels: 509,
};
export const sprites: readonly PixelSprite[] = [variant0];
